import React from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {setFavoritePage} from "../actions/FavoriteAppActions";

const Pagination  = props => {

  const {page, page_size, count, next, previous, setFavoritePage} = props
  const selector = "#favoritedetail";
  const max_total = 10;
  const max_delta = 2;
  const max_page = Math.ceil(count / page_size);

  const numberRange = (start, end)=> {
      return new Array(end - start ).fill().map((d, i) => i + start);
  }

  const handleGoToPage = (e, num) =>{
    if(num!==null){
        setFavoritePage(num);
    }
    let $container = $(selector);
    if(!_.isUndefined($container)){
        $('html, body').animate({
            scrollTop: $container.offset().top - 100
        }, 500)
    }
    e.preventDefault();
  }

  const pageList = () => {
      let c_page = page,
          first_interval,
          last_interval;

      if (max_page > max_total){
          if (c_page > 2 * max_delta){
            first_interval = numberRange(1, max_delta + 1);
            first_interval.push(0);
            first_interval.push(c_page-1);
            first_interval.push(c_page);
            if (c_page + 2 * max_delta > max_page){
                //last interval
                last_interval = numberRange(c_page+1, max_page + 1);
            }else{
                first_interval.push(c_page+1);
                if (c_page+1 != max_page-max_delta){
                    first_interval.push(0);
                }
                //last interval
                last_interval = numberRange(max_page-max_delta, max_page + 1);
            }

          }else{
              let mval = Math.max(c_page + max_delta, 2 * max_delta)
              first_interval = numberRange(1, mval);
              first_interval.push(0);
              //last interval
              last_interval = numberRange(max_page-max_delta, max_page + 1);
          }

          /*
        if (c_page > max_delta + 1){
            first_interval = numberRange(1, max_delta + 1);
            first_interval.push(0);
            first_interval.push(c_page);
        }else{
            first_interval = numberRange(1, max_delta + 1);
        }

        if (c_page < max_page - max_delta -1){
            last_interval = numberRange(max_page - max_delta, max_page + 1);
            last_interval.unshift(0);
        }else{
            last_interval = numberRange(c_page, max_page + 1);
        }
        */
        return first_interval.concat(last_interval)

      }else{
          return numberRange(1, max_page + 1);
      }
  }


  const firstPage = () => {
       if (page > 1){
           return page - 1
      }
      return 0
  }

  const lastPage = () => {
      if (page < max_page){
          return page + 1
      }

      return 0
  }
  const first_page = firstPage();
  const last_page = lastPage();
  const page_list = pageList();


  return (
      <nav className="d-flex justify-content-center">
          <ul className="pagination">
              <li className="page-item">
                  {first_page !== 0 ?
                      <a className="page-link"
                         href={`?page=${first_page}`}
                         aria-label="Назад"
                         onClick={e => handleGoToPage(e, first_page)}>
                          <span aria-hidden="true">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                   className="bi bi-chevron-left" viewBox="0 0 16 16">
                                  <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
                              </svg>
                          </span>
                      </a>
                      :
                      <span className="page-link disabled" aria-hidden="true">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                               className="bi bi-chevron-left" viewBox="0 0 16 16"><path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg>
                      </span>
                  }
              </li>
              {page_list.map((page_item, p_ind) => (
                  page_item === 0 ?
                      <li className="page-item" key={p_ind}><span className="page-link disabled">...</span></li>
                      :
                      page_item == page ?
                          <li className="page-item active" key={p_ind}><span className="page-link">{page_item}</span></li>
                          :
                          <li className="page-item" key={p_ind}>
                              <a className="page-link"
                                 href={`?page=${page_item}`}
                                 onClick={e => handleGoToPage(e, page_item)}>
                                  {page_item}
                              </a>
                          </li>
              ))}
              <li className="page-item">
                  {last_page !== 0 ?
                      <a className="page-link"
                         href={`?page=${last_page}`}
                         aria-label="Далее"
                         onClick={e => handleGoToPage(e, last_page)}>
                          <span aria-hidden="true">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                   className="bi bi-chevron-right" viewBox="0 0 16 16">
                                  <path fillRule="evenodd"
                                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
                              </svg>
                          </span>
                      </a>
                      :
                      <span className="page-link disabled" aria-hidden="true">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                               className="bi bi-chevron-right" viewBox="0 0 16 16">
                              <path fillRule="evenodd"
                                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
                          </svg>
                      </span>
                  }
              </li>
          </ul>
      </nav>
  )
}

const mapStateToProps = state => ({
    page: state.favorite.page,
    page_size: state.favorite.page_size,
    count: state.favorite.count,
    status: state.favorite.status,
    next: state.favorite.next,
    previous: state.favorite.previous,
})

const mapDispatchToProps = dispatch => bindActionCreators({setFavoritePage}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pagination)